import styled from 'styled-components';
import LeftArrow from '../assets/svg/LeftArrow';
import RightArrow from '../assets/svg/RightArrow';
import GalleryToolTip from '../assets/svg/GalleryToolTip';
import GalleryToolTipMobile from '../assets/svg/GalleryToolTipMobile';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import React, { useRef, useState } from 'react';
import '../assets/style.css';

import { PUBLIC_IMAGES_REPO } from '../../../utils/Constants';

const Image2 = `https://images.boostfloral.com/publicImagesRepo/floral-gallery-image-2.webp`;
const Image3 = `https://images.boostfloral.com/publicImagesRepo/floral-gallery-image-3.webp`;
const Image4 = `https://images.boostfloral.com/publicImagesRepo/floral-gallery-image-4.webp`;
const Image5 = `https://images.boostfloral.com/publicImagesRepo/floral-gallery-image-5.webp`;
const Image8 = `https://images.boostfloral.com/publicImagesRepo/floral-gallery-image-8.webp`;
const Image9 = `https://images.boostfloral.com/publicImagesRepo/floral-gallery-image-9.webp`;
const Image10 = `https://images.boostfloral.com/publicImagesRepo/floral-gallery-image-10.webp`;
const Image11 = `https://images.boostfloral.com/publicImagesRepo/floral-gallery-image-11.webp`;
const Image12 = 'https://images.boostfloral.com/image-repository//boostfloral_vase_of_flowers_in_a_home_kitchen_beying_admired_64a2fdfa-f8b7-42a9-a859-f397daf3698b.png';
const Image13 = 'https://thumbnails.boostfloral.com/image-gallery/valentines_day_banner_abd3b59302a-47648-1729749792747.png';
const Image14 = 'https://thumbnails.boostfloral.com/image-repository//boostfloral_vase_of_flowers_in_a_home_kitchen_beying_admired_57f45219-fc3c-4b6c-a9e4-d751fe8eaea7.png';
const Image15 = 'https://images.boostfloral.com/image-repository//boostfloral_greenhouse_red_roses_light_blurred_background_beying_ad_648bc12b-0eb7-4322-8d27-450be97b7ea6.png';
const Image16 = 'https://images.boostfloral.com/image-repository//boostfloral_hero_image_for_website_floral_arrangement_light_blurred_e29a3201-2c9d-4d0b-b937-2721ede68856.png';
const Image17 = 'https://thumbnails.boostfloral.com/image-repository//Boostfloral_traditional_vased_flower_arrangement_light_background_b_ef1f810b-b0b3-4c64-868d-c23663053aaf.png';
const Image18 = 'https://images.boostfloral.com/image-repository//boostfloral_greenhouse_red_roses_light_blurred_background_beying_ad_3391f3a3-009f-42fc-acd0-738ffae50e46.png';
const Image19 = 'https://images.boostfloral.com/image-repository//josh22r_website_banner_for_christmas_day_snowflakes_in_backgro_534209bd-16ea-474d-be9a-4c1964db31b4.png';
const Image20 = 'https://images.boostfloral.com/image-repository//boostfloral_hero_image_for_website_floral_arrangement_outdoors_ligh_a9c58258-0952-4a7f-9c76-352d18cc965f.png';
const Image21 = 'https://thumbnails.boostfloral.com/image-repository//boostfloral_vase_of_flowers_in_a_home_beying_admired_3e14135c-d907-40c5-92df-5a00d924f48e.png'
const Image22 =  'https://images.boostfloral.com/image-repository//boostfloral_greenhouse_roses_light_blurred_background_beying_admire_4f1572ce-c886-4b5b-a696-928e47284aa0.png';
const Image23 =  'https://images.boostfloral.com/image-repository//vased_bouquet_black_background.png';
const Wrapper = styled.section`
  background: var(--BG-Color, #f2f2f2);

  img {
    min-height: 195px;
  }

  .container {
    max-width: 1440px;
    padding: 6.25rem 0;
    position: relative;
    overflow: hidden;
  }

  .gallery-images {
    display: flex;
    height: 400px;
    flex-direction: column;
    width: 300px;
  }

  .gallery-tooltip-desktop {
    position: absolute;
    top: -1%;
    right: 12%;

    svg {
      width: 85%;
    }
  }

  .gallery-tooltip-mobile {
    display: none;
  }

  .header {
    padding: 0 6.25rem;

    .slider-buttons {
      position: absolute;
      right: 10%;
      top: 9.375rem;
    }

    h2 {
      color: var(--font-color-font-1, #1b131f);
      font-family: Instrument Sans;
      font-size: 64px;
      font-style: normal;
      font-weight: 700;
      line-height: 88px;
      margin-bottom: 24px;
      text-align: center;
    }

    p {
      color: var(--font-color-font-1, #1b131f);
      text-align: center;
      font-family: Instrument Sans;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px;
    }
  }

  .gallery {
    // display: flex;
    margin-top: 3rem;
  }

  @media screen and (max-width: 1024px) {
    .gallery-tooltip-desktop {
      position: absolute;
      top: 0%;
      right: -2%;

      svg {
        width: 65%;
      }
    }

    .header {
      .slider-buttons {
        right: 6%;
      }

      h2 {
        font-size: 45px;
        line-height: 58px;
        margin-bottom: 1.25rem;
      }

      p {
        font-size: 18px;
        line-height: 28px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .container {
      padding: 4rem 1.25rem 2rem 1.25rem;
    }

    .gallery-tooltip-desktop {
      display: none;
    }

    .gallery-tooltip-mobile {
      display: block;
      position: absolute;
      top: 0%;
      right: 2%;

      svg {
        width: 95%;
      }
    }

    .header {
      padding: 0;

      .slider-buttons {
        display: none;
        position: absolute;
        right: 10%;
        top: 9.375rem;
      }

      h2 {
        font-size: 32px;
        line-height: 40px;
        margin-bottom: 8px;
      }

      p {
        font-size: 16px;
        line-height: 24px;
      }
    }

    .gallery {
      margin-top: 3rem;

      img:nth-child(even) {
        margin-bottom: 0.75rem;
      }

      img:nth-child(odd) {
        margin-top: 1rem;
      }
    }
  }
`;

const ImageGallery = () => {
  const [isLeftArrowDisabled, setIsLeftArrowDisabled] = useState(true);
  const [isRightArrowDisabled, setIsRightArrowDisabled] = useState(false);

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    adaptiveHeight: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const sliderRef = useRef();

  const handleBeforeChange = (currentSlide, nextSlide) => {
    // Check if the left arrow should be disabled
    setIsLeftArrowDisabled(nextSlide === 0);

    // Check if the right arrow should be disabled
    const totalSlides = sliderRef.current.props.children.length;
    const slidesToShow = settings.slidesToShow;
    setIsRightArrowDisabled(nextSlide + slidesToShow >= totalSlides);
  };
  return (
    <Wrapper>
      <div className="container">
        <div className="gallery-tooltip-desktop">
          <GalleryToolTip />
        </div>

        <div className="gallery-tooltip-mobile">
          <GalleryToolTipMobile />
        </div>

        <div className="header d-flex flex-column align-items-center">
          <div className="slider-buttons">
            <LeftArrow
              onClick={() => sliderRef?.current?.slickPrev()}
              isDisabled={isLeftArrowDisabled}
            />
            <RightArrow
              onClick={() => sliderRef?.current?.slickNext()}
              isDisabled={isRightArrowDisabled}
            />
          </div>

          <h2>Floral Image Gallery</h2>
          <p>Thousands of stock Floral Images and Banners available</p>
        </div>

        <div className="gallery">
          <Slider
            {...settings}
            ref={sliderRef}
            beforeChange={handleBeforeChange}
          >
            <div className="gallery-images">
              <img loading="lazy" src={Image2} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
              <img loading="lazy" src={Image8} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
            </div>
            <div className="gallery-images">
              <img loading="lazy" src={Image3} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
              <img loading="lazy" src={Image9} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
            </div>
            <div className="gallery-images">
              <img loading="lazy" src={Image4} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
              <img loading="lazy" src={Image10} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
            </div>
            <div className="gallery-images">
              <img loading="lazy" src={Image5} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
              <img loading="lazy" src={Image11} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
            </div>
            <div className="gallery-images">
              <img loading="lazy" src={Image12} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
              <img loading="lazy" src={Image13} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
            </div>
            <div className="gallery-images">
              <img loading="lazy" src={Image14} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
              <img loading="lazy" src={Image15} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
            </div>
            <div className="gallery-images">
              <img loading="lazy" src={Image16} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
              <img loading="lazy" src={Image17} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
            </div>
            <div className="gallery-images">
              <img loading="lazy" src={Image18} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
              <img loading="lazy" src={Image19} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
            </div>
            <div className="gallery-images">
              <img loading="lazy" src={Image20} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
              <img loading="lazy" src={Image21} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
            </div>
            <div className="gallery-images">
              <img loading="lazy" src={Image22} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
              <img loading="lazy" src={Image23} alt="Floral image for Flower shop online store or Floral e-commerce website gallery" />
            </div>
          </Slider>
        </div>
      </div>
    </Wrapper>
  );
};

export default ImageGallery;
